import React, { useState } from 'react';
import { Search, BookOpen, Sparkles, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';

const Hero = ({ onSearch }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      onSearch(searchQuery);
    }
  };

  return (
    <div className="relative overflow-hidden bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="p-3 bg-blue-50 rounded-2xl">
              <BookOpen className="w-12 h-12 text-blue-600" />
            </div>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6 tracking-tight">
            Modern Bible Study
            <span className="block text-blue-600 mt-2">Powered by AI</span>
          </h1>
          
          <p className="text-xl text-slate-600 mb-12 max-w-2xl mx-auto leading-relaxed">
            Everything you need to study the Bible in an enjoyable and enriching manner.
            Search, compare translations, and gain deep insights with AI assistance.
          </p>
          
          <form onSubmit={handleSearch} className="max-w-2xl mx-auto mb-8">
            <div className="flex gap-3">
              <div className="relative flex-1">
                <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5" />
                <Input
                  type="text"
                  placeholder="Search for verses, topics, or ask AI anything..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="pl-12 h-14 text-lg border-slate-200 focus:border-blue-500 transition-colors"
                />
              </div>
              <Button 
                type="submit" 
                size="lg" 
                className="h-14 px-8 bg-blue-600 hover:bg-blue-700 transition-all duration-200"
              >
                <Sparkles className="w-5 h-5 mr-2" />
                Search
              </Button>
            </div>
          </form>
          
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <button
              onClick={() => onSearch('John 3:16')}
              className="px-4 py-2 bg-white border border-slate-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-all duration-200"
            >
              John 3:16
            </button>
            <button
              onClick={() => onSearch('Psalm 23')}
              className="px-4 py-2 bg-white border border-slate-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-all duration-200"
            >
              Psalm 23
            </button>
            <button
              onClick={() => onSearch('love')}
              className="px-4 py-2 bg-white border border-slate-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-all duration-200"
            >
              Search "love"
            </button>
          </div>
        </div>
      </div>
      
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-100 rounded-full filter blur-3xl opacity-20 -z-10"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-100 rounded-full filter blur-3xl opacity-20 -z-10"></div>
    </div>
  );
};

export default Hero;
